import { PropsWithChildren } from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

export const RouteErrorBoundary = ({ resetKeys = [], ...restProps }: PropsWithChildren<ErrorBoundaryProps>) => {
  const location = useLocation();

  return <ErrorBoundary resetKeys={[location.pathname, location.search, ...resetKeys]} {...restProps} />;
};
